import {enumType} from '../common/enumType';
import {RecurrenceType} from './RecurrenceType';
import {FtpTransferMode} from './diplomat/enums/FtpTransferMode';
import {FileTransferVerifyType} from './FileTransferVerifyType';
import {DiplomatObjectAceType} from './diplomat/settings/permissions/DiplomatObjectAceType';
import {AdminResourceType} from './diplomat/settings/adminroles/AdminResourceType';

/**
 * It's a generated file, preferable to extend this in external file
 */

export const enums = {
   DayOfWeek: enumType({
      SUNDAY: 'Sun',
      MONDAY: 'Mon',
      TUESDAY: 'Tue',
      WEDNESDAY: 'Wed',
      THURSDAY: 'Thu',
      FRIDAY: 'Fri',
      SATURDAY: 'Sat',
   }),
   DiplomatObjectType: [
      'Primary Archive Settings',
      'Audit Trail Settings',
      'Authentication Policies',
      'Backup Settings',
      'Config Settings',
      'Email Server Settings',
      'OpenPGP Server Settings',
      'Public Partner',
      'Folder',
      'FTP Server Settings',
      'FTP Settings',
      'Holiday Calendar',
      'Inbound Transaction',
      'Trusted Partner',
      'IT Support Email Settings',
      'Job History Settings',
      'Job Settings',
      'Job Suspension',
      'OpenPGP Key Pair',
      'OpenPGP Key Settings',
      'Log File Settings',
      'Outbound Transaction',
      'Paging Settings',
      'Password Data',
      'Proxy Server',
      'OpenPGP Public Key',
      'Scheduled Report',
      'Session Data',
      'SSH Key',
      'SSH Host Key',
      'SSL Certificate',
      'SSL Client Certificate',
      'Timeout/Retry Settings',
      'User',
      'AS2',
   ],
   zipType: enumType({
      NONE: 'NONE',
      ZIP: 'ZIP',
      GZIP: 'GZIP',
   }),
   LicenseEdition: enumType({
      ENTERPRISE: 'Enterprise',
      PROFESSIONAL: 'Professional',
      STANDARD: 'Standard',
      BASIC: 'Basic',
      COMMUNITY: 'OpenPGP Community',
      CLOUD: 'Cloud Storage Community',
   }),
   DiplomatFeature: [
      'ADDITIONAL_ARCHIVE',
      'ADVANCED_REPORTING',
      'ADVANCED_TROUBLESHOOTING',
      'AEKS',
      'ALL_CLOUDS',
      'AMAZONS3_TRANSPORT',
      'API',
      'ARCHIVE_ADMIN',
      'ARCHIVE_FILE_CHOICE',
      'ARCHIVING',
      'AUDIT_CRITICAL',
      'AUDIT_TRAIL',
      'AUTHENTICATED_LOGIN',
      'AZURE_TRANSPORT',
      'BACKUP_RESTORE',
      'BACKUP_SETTINGS',
      'BOX_TRANSPORT',
      'BUSINESS_USER_EMAIL',
      'CLOUD_TRANSPORT',
      'COMMAND_LINE_INTERFACE',
      'COPY_NUMBER',
      'DATA_AGENT_TRANSPORT',
      'DATE_AND_SEQUENCE_PARAMETERS',
      'DEFAULT_TRANS_SETTINGS',
      'DELAY_JOBS',
      'DELETE_ARCHIVE_DEFAULT',
      'DROPBOX_TRANSPORT',
      'EMAIL_TRANSPORT',
      'EXPLICIT_FTP_TIMEOUT',
      'FILE_INTEGRITY_CHECK',
      'FILESYSTEM_MONITOR_SCHEDULING',
      'FTP_SERVER_ADMIN',
      'FTP_SETTINGS',
      'FTP_TRANSPORT',
      'GOOGLE_CLOUD_TRANSPORT',
      'HIGH_PRIORITY_JOBS',
      'HOLIDAY_CALENDAR',
      'HTTP_TRANSPORT',
      'IT_EMAIL',
      'JOB_HISTORY',
      'JOB_MONITOR',
      'JOB_QUEUE_CONTROL',
      'JOB_STATUS_INDICATION',
      'JOB_SUSPENSION',
      'KEY_RECOVERY',
      'KEY_RING_IMPORTING',
      'LOG_FILE_ADMIN',
      'LOG_FILE_MAINTENANCE',
      'MERGE',
      'MOVE',
      'MULTIPLE_FILENAME_FIELDS',
      'ORACLE_CLOUD_TRANSPORT',
      'PAGING',
      'PARTNERS',
      'PRE_POST_COMMANDS',
      'PROXY_SERVER',
      'REPORTING',
      'RESTORE_CONFIG',
      'RETAIN_MODIFIED_DATE',
      'REVIEWER_USERS',
      'SEARCH',
      'SELECTIVE_MERGE',
      'SHAREFILE_TRANSPORT',
      'SMB_TRANSPORT',
      'SQL_AUDIT_TRAIL',
      'SSH_KEYS',
      'SSL_CERTIFICATES',
      'STATUS_DIALOG',
      'SUBKEY_ADDITION',
      'THIRD_PARTY_SCHEDULING',
      'TRANSLATE_INVALID_CHARS',
      'USE_TEMP_FILENAMES',
      'USER_ACTIVITY',
      'USER_ADMIN',
      'ZIP',
      'AS2_TRANSPORT',
      'FILE_TRIGGER',
      'SOURCE_FILE_MOVE',
   ],
   algorithm: [
      'DSA',
      'ELGAMAL_ENCRYPT',
      'ELGAMAL_GENERAL',
      'RSA_ENCRYPT',
      'RSA_GENERAL',
      'RSA_SIGN',
      'ECDH',
      'ECDSA',
      'DH',
   ],
   overwriteStatus: enumType({
      FALSE: 'False',
      TRUE: 'True',
      UNDEFINED: 'Undefined',
   }),
   keyType: ['DSA', 'RSA', 'ECDSA', 'ECDH', 'DH'],
   SshKeyType: ['DSS', 'RSA', 'ECDSA', 'ECDH'],
   SymmetricAlgorithm: [
      'AES-128',
      'AES-192',
      'AES-256',
      'BLOWFISH',
      'CAST5',
      'DES',
      'IDEA',
      'SAFER',
      'TRIPLE-DES',
      'TWOFISH',
   ],
   HashAlgorithm: ['MD5', 'RIPEMD160', 'SHA1', 'SHA224', 'SHA256', 'SHA384', 'SHA512'],
   sourceDateRange: enumType({
      ALL: 'All Dates',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      TOMORROW: 'Tomorrow',
      LAST_WEEK: 'Within the Last Week',
      LAST_2_WEEKS: 'Within the Last 2 Weeks',
      LAST_MONTH: 'Within Last Month',
      LAST_QUARTER: 'Within Last 3 Months',
      LAST_YEAR: 'Within Last Year',
   }),
   sourceTimeRange: enumType({
      ALL: 'All Dates',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      TOMORROW: 'Tomorrow',
      SINCELASTEXECUTION: 'Since Last Successful Execution',
      LAST_WEEK: 'Within the Last Week',
      LAST_2_WEEKS: 'Within the Last 2 Weeks',
      LAST_MONTH: 'Within Last Month',
      LAST_QUARTER: 'Within Last 3 Months',
      LAST_YEAR: 'Within Last Year',
      MOST_RECENT: 'Most Recent',
      OLDEST: 'Oldest',
   }),
   destinationDateType: enumType({
      SOURCE_DATE: 'Source Filename Date',
      SOURCE_MODIFY_DATE: 'Source Modified Date',
      TODAY: 'Today',
      TOMORROW: 'Tomorrow',
      YESTERDAY: 'Yesterday',
      LAST_SUNDAY: 'Last Sunday',
      LAST_MONDAY: 'Last Monday',
      LAST_TUESDAY: 'Last Tuesday',
      LAST_WEDNESDAY: 'Last Wednesday',
      LAST_THURSDAY: 'Last Thursday',
      LAST_FRIDAY: 'Last Friday',
      LAST_SATURDAY: 'Last Saturday',
      END_LAST_MONTH: 'End Of Last Month',
      END_LAST_QARTER: 'End Of Last Quarter',
      END_LAST_YEAR: 'End Of Last Year',
   }),
   overwriteType: enumType({
      ALWAYS: 'Overwrite',
      DATE: 'Overwrite if source newer',
      SIZE: 'Overwrite if different size',
      DATE_OR_SIZE: 'Overwrite if source newer or different size',
      // SYNCHRONIZATION: 'Synchronization',
      NEVER: 'Do not overwrite',
      SYNCHRONIZATION: 'SYNCHRONIZATION',
   }),
   sourceFtpMode: FtpTransferMode,
   destinationFtpMode: FtpTransferMode,
   transferOrder: enumType({
      DEFAULT: 'Default',
      ASCENDING: 'Alphabetical (A-Z)',
      DESCENDING: 'Alphabetical (Z-A)',
      OLDESTFIRST: 'Oldest First',
      NEWESTFIRST: 'Newest First',
   }),
   transType: enumType({
      INBOUND: 'INBOUND',
      OUTBOUND: 'OUTBOUND',
      SYNCHRONIZATION: 'SYNCHRONIZATION',
   } as const),
   TransportType: [
      'Amazon S3',
      'Azure Storage',
      'Box',
      'Cloud',
      'Dropbox',
      'EMAIL',
      'Local Network',
      'FTP',
      'FTPS',
      'Google Cloud',
      'HTTP',
      'HTTPS',
      'OracleCloud',
      'SFTP',
      'ShareFile',
      'SMB',
      'AS2',
   ],
   fileTransferVerifyType: ['SIZE', 'HASH', 'NONE'],
   smblibrary: ['JCIFS', 'SMBJ'],
   ServerType: ['Windows/Unix', 'AS400/IFS', 'AS400/Library', 'MVS/IFS'],
   storageType: ['FILE', 'APPEND_BLOB', 'BLOCK_BLOB', 'PAGE_BLOB'],
   shareFileFolderType: ['PERSONAL', 'SHARED'],
   proxyType: enumType({
      HTTP: 'HTTP',
      SOCKS5: 'SOCKS5',
   }),
   dbType: enumType({
      SQL: 'SQL',
      XML: 'Standard',
   }),
   sqlDbType: enumType({
      CUSTOM: 'Custom JDBC',
      MYSQL: 'MySQL',
      SQL_SERVER: 'SQL Server',
   }),
   HolidayBehavior: enumType({
      DO_NOT_SCHEDULE: 'Do Not Schedule',
      SCHEDULE_DAY_AFTER: 'Schedule Next Business Day',
      SCHEDULE_DAY_BEFORE: 'Schedule Prior Business Day',
   }),
   status: ['COMPLETED', 'QUEUED', 'RUNNING'],
   completionStatus: ['CANCELLED', 'ERROR', 'NOT_PROCESSED', 'SUCCESSFUL', 'TERMINATED', 'WARNING'],
   recurrenceType: RecurrenceType,
   months: enumType({
      JANUARY: 'January',
      FEBRUARY: 'February',
      MARCH: 'March',
      APRIL: 'April',
      MAY: 'May',
      JUNE: 'June',
      JULY: 'July',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'October',
      NOVEMBER: 'November',
      DECEMBER: 'December',
   }),
   State: enumType({
      SUSPENDED_AUDIT_FAILURE: 'Suspended - Audit Failure',
      SUSPENDED_RESTORE: 'Suspended - DB Restore',
      SUSPENDED: 'Suspended',
      NOT_SUSPENDED: 'Not Suspended',
      DIRECTLY_SUSPENDED: 'Directly Suspended',
      INDIRECTLY_SUSPENDED: 'Indirectly Suspended',
      NOT_SCHEDULABLE: 'Not Scheduled',
      SCHEDULABLE: 'Scheduled',
      FILESYSTEM_MONITOR: 'Monitoring',
      EXTERNAL_REQUEST: 'External Request',
      DISABLED: 'Disabled',
   } as const),
   style: enumType({
      INDIVIDUAL: 'Individually',
      TOGETHER: 'Together',
   }),
   encryption: enumType({
      NONE: 'None',
      AES128: 'AES-128',
      AES256: 'AES-256',
      ZIP: 'Zip2.0',
   }),
   overwrite: enumType({
      ALWAYS: 'Overwrite',
      DATE: 'Overwrite if source newer',
      SIZE: 'Overwrite if different size',
      DATE_OR_SIZE: 'Overwrite if source newer or different size',
      NEVER: 'Do not overwrite',
   }),
   archiveFileType: enumType({
      SOURCE: 'Source',
      DESTINATION: 'Destination',
      BOTH: 'Both',
   }),
   role: enumType({
      ADMINISTRATOR: 'Administrator',
      USER: 'Manager',
      REVIEWER: 'Reviewer',
   }),
   component: enumType({
      API: 'API',
      REST_API: 'REST API',
      CLIENT: 'Client',
      INTERNAL: 'Internal',
      JOB_MONITOR: 'Job Monitor',
   }),
   reportingLevel: enumType({
      CRITICAL: 'Critical Error',
      ERRORS: 'Error',
      WARNINGS: 'Warning',
      SUCCESS: 'Success',
      ALL: 'All',
   }),
   pagertype: enumType({
      NO_PAGING: 'No Paging',
      EMAIL: 'Email',
      FILE: 'File',
   }),
   passwordUpdateInterval: enumType({
      NONE: 'None',
      THREE_MONTH: '3 Months',
      SIX_MONTH: '6 Months',
      ONE_YEAR: '1 Year',
   }),
   fileReadyConditions: ['None', 'File Locking', 'Trigger File'],
   postTransferActions: ['None', 'Delete', 'Move'],
   scheduleTriggers: ['None', 'Schedule', 'File Monitor'],
   verifyTransfers: FileTransferVerifyType,
   azureStorageType: ['FILE', 'APPEND_BLOB', 'BLOCK_BLOB', 'PAGE_BLOB'],
   folderType: ['PERSONAL', 'SHARED'],
   authStrategy: ['PASSWORD', 'NETWORK', 'TWO_FACTOR'],
   licenseType: enumType({
      PAID: 'Paid',
      TRIAL: 'Trial',
      PREVIEW: 'Preview',
   }),
   commandType: enumType({
      PRE: 'PRE',
      POST: 'POST',
   }),
   filterType: enumType({
      TIME_FILTER: 'TIME_FILTER',
      TRANS_FILTER: 'TRANS_FILTER',
      TEXT_FILTER: 'TEXT_FILTER',
      LOG_LEVEL_FILTER: 'LOG_LEVEL_FILTER',
   }),
   minimumLevel: enumType({
      LOG_NOTHING: 'Nothing',
      LOG_CRITICAL: 'Critical Error',
      LOG_ERRORS: 'Error',
      LOG_WARNINGS: 'Warning',
      LOG_NOTIFICATIONS: 'Notification',
      LOG_INFORMATIONAL: 'Informational',
      LOG_DEBUG: 'Debug',
      LOG_FULL: 'Full',
   }),
   recurseOrder: enumType({
      DEPTHFIRST: 'Depth First',
      BREADTHFIRST: 'Breadth First',
   }),
   patternType: enumType({STRING: 'String', REGEX: 'Regex'}),
   includedObjects: enumType({
      DIRECTORIES: 'Directories',
      FILES: 'Files',
      BOTH: 'Both',
   }),
   matchType: enumType({
      INCLUDE: 'Include',
      EXCLUDE: 'Exclude',
   }),
   edgeGatewayStatus: enumType({
      CONNECTED: 'CONNECTED',
      CONNECTING: 'CONNECTING',
      PING_ERROR: 'PING_ERROR',
      PNC_ERROR: 'PNC_ERROR',
   }),
   VFSAceType: enumType({
      DELETE_FOLDER: 'DELETE_FOLDER',
      LIST_FOLDER: 'LIST_FOLDER',
      WRITE_FILE: 'WRITE_FILE',
      DELETE_FILE: 'DELETE_FILE',
      READ_FILE: 'READ_FILE',
      CREATE_FOLDER: 'CREATE_FOLDER',
   }),
   vfsType: enumType({
      PHYSICAL: 'PHYSICAL',
      VIRTUAL: 'VIRTUAL',
   }),
   entryType: ['USER', 'GROUP'],
   bindingType: enumType({
      ANONYMOUS: 'Anonymous',
      AUTHENTICATED: 'Authenticated',
   }),
   ldapType: enumType({
      SFTP: 'SFTP',
      ADMIN: 'ADMIN',
   }),
   reportFormats: enumType({
      PDF: 'PDF',
      CSV: 'CSV',
   }),
   eccurveType: enumType({
      NISTP256: 'NISTP256',
      NISTP384: 'NISTP384',
      NISTP521: 'NISTP521',
      Ed25519: 'Ed25519',
      // UNKNOWN: 'UNKNOWN',
   }),
   eccurveTypeCreatable: enumType({
      NISTP256: 'NISTP256',
      NISTP384: 'NISTP384',
      NISTP521: 'NISTP521',
   }),
   eccurveTypeBitStrength: enumType({
      1: 'NISTP256',
      2: 'NISTP384',
      3: 'NISTP521',
   }),

   signatures: enumType({
      'ssh-ed25519': 'ssh-ed25519',
      'rsa-sha2-512': 'rsa-sha2-512',
      'rsa-sha2-256': 'rsa-sha2-256',
      'ssh-rsa': 'ssh-rsa',
      'ecdsa-sha2-nistp521': 'ecdsa-sha2-nistp521',
      'ecdsa-sha2-nistp384': 'ecdsa-sha2-nistp384',
      'ecdsa-sha2-nistp256': 'ecdsa-sha2-nistp256',
   }),

   AdminResourceType,
   DiplomatObjectAceType,
   TimeRangeReportType: enumType({
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      THIS_WEEK: 'This Week',
      THIS_MONTH: 'This Month',
      THIS_QUARTER: 'This Quarter',
      THIS_YEAR: 'This Year',
   }),
   regionCodes: enumType({
      US: 'US',
      IN: 'IN',
      CN: 'CN',
      EU: 'EU',
      AU: 'AU',
   }),
   acessControlBehavior: enumType({ALLOW: 'Allow', DENY: 'Deny'}),
};
